import { externalCpd } from './external-cpd';
import { searchTile } from './searchtile';

export const endpoints = {
  externalCpd,
  searchTile
}


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/testing-portal/pressure-test/config/endpoints/index.js